/**
 * Takes a semver style number and returns the major value.
 * @param  {string} semver Semver version number. i.e. 1.2.5
 * @return {int} The major semver number.
 */
export const getMajorSemverNumber = (semver) =>
    parseInt(semver.split('.')[0], 10);
